import { SERVICE_ENDPOINTS } from 'utils';

export const getCurrencies = (state) => state.config;
export const getPosLanguages = (state) => state.config.settings.pos_languages;
export const getCountry = (state) => state.config.settings.country;
export const getTimezone = (state) => state.config.settings.timezone;
export const getDateFormat = (state) => state.config.settings.dateformat;
export const getNumberFormat = (state) => state.config.settings.numberformat;

/**
 * Find a setting by its name
 * @param {string} key - name of the config
 * @returns {String}  configValue
 */
export const getSetting = (key) => (state) => state.config.settings[key];

export const getSettings = (state) => state.config.settings;

export const getServiceEndpoints = () =>
  JSON.parse(localStorage.getItem(SERVICE_ENDPOINTS) || '{}');

export const getEndpointForService = (name) =>
  getServiceEndpoints()[name] || {};

export const getCAFAEndpoint = () => getEndpointForService('cafa');
export const getAuthEndpoint = () => getEndpointForService('auth');
export const getAccountAdminEndpoint = () =>
  getEndpointForService('account-admin');
